/**
 * @ngdoc directive
 * @name ng.directive:ngVideoShort
 * @element ANY
 */

const ngVideoShort = function () {
    return {
        link: function ( $scope, $item, $params ) {
            const short = $scope.$parent.shorts[$params.ngVideoShort];
            short.videoElement = $item[0];

            // First check for native browser HLS support
            if($scope.nativeHlsSupported && short.video.hls) {
                short.videoElement.src = short.video.hls;

                // If no native HLS support, check if HLS.js is supported
            } else if($scope.hlsObject && short.video.hls) {
                if(short.playing) {
                    $scope.hlsObject.loadSource(short.video.hls);
                    $scope.hlsObject.attachMedia(short.videoElement);
                }

                // Fallback to mp4
            } else {
                short.videoElement.src = short.video.mp4;
            }

            short.videoElement.addEventListener('loadedmetadata', function() {
                short.videoElement.dataset.loaded = 'true';
                short.videoElement.muted = short.muted;

                if(short.playing) {
                    short.videoElement.play().then(() => $scope.$apply(), (err) => $scope.$apply());
                }
            }, {passive: true});
        }
    };
};

export default ngVideoShort;
